import { Utility } from "./utility.js"

export class Help extends Phaser.Scene {
    constructor(options) {
        super({key: "help"});
        this._options = options
    }
    preload() {
        this.load.image("game-over-background", "assets/game-over-background.jpg");
    }
    create() {
        let board = this.add.container(180, 88).setSize(840,520)
        board.add(this.add.graphics().fillStyle(0x070b34, 1).fillRoundedRect(0, 0, board.width, board.height, 24))
        board.add(this.physics.add.staticImage(board.width / 2,0, "help-icon"))
        board.add(Utility.make.text(this, board.width / 2, 72, "Your Task:", {fontSize: "28px", fill: "#ff0000", strokeThickness: 3}).setOrigin(.5).setResolution(2))
        board.add(Utility.make.text(this, 72, 108, this._options.description,
            {fontSize: `20px`, align: 'center', lineSpacing: "2", wordWrap: { width: 720, useAdvancedWrap: true }}).setResolution(2))
        board.add(this.add.line(180,192,760,40,240,40,0xffffff, .5))
        board.add(this.physics.add.staticImage(board.width / 2 - 200, 292, "help-arrows"))
        board.add(Utility.make.text(this, board.width / 2 - 200, 360, "Use the arrow keys to move the character", {fontSize: `16px`, fill: "#C6C6C6", align: 'center', wordWrap: { width: 140, useAdvancedWrap: true }}).setOrigin(0.5).setResolution(1))
        board.add(this.physics.add.staticImage(board.width / 2, 292, "help-space-bar"))
        board.add(Utility.make.text(this, board.width / 2, 360, "Press space bar to pick up /drop an object", {fontSize: "16px", fill: "#C6C6C6", align: 'center', wordWrap: { width: 132, useAdvancedWrap: true }}).setOrigin(0.5).setResolution(1))   
        board.add(this.physics.add.staticImage(board.width / 2 + 200, 292, "help-esc"))
        board.add(Utility.make.text(this, board.width / 2 + 200, 360, 'Press "Esc" to go back to the home menu screen', {fontSize: "16px", fill: "#C6C6C6", align: 'center', wordWrap: { width: 160, useAdvancedWrap: true }}).setOrigin(0.5).setResolution(1))
        let home = Utility.make.button("< HOME", {scene: this, x: board.width / 2 - 100, y: 450, color: 0xffa500, hover: 0xcca500}).setScale(.75)
        let resume = Utility.make.button("RESUME >", {scene: this, x: board.width / 2 + 100, y: 450}).setScale(.75)
        board.add([home, resume])
        home.on('pointerdown', ()=> {
            const overlay = this.add.graphics().fillStyle(0x000000, .85).fillRoundedRect(board.x, board.y, board.width, board.height,24)
            Utility.make.dialog.confirmation(this, {
                title: "Back to Home Menu",
                message: "Are you sure you want to leave this level? You will lose your stars",
                scale: 1,
                proceed: () => this._options.home(),
                cancel: () => overlay.destroy()
            })
        })
        resume.on('pointerdown', () => this._options.cancel())
    }
}